import * as React from "react";
import { Provider as UrlqProvider } from "urql";
import { urqlClient } from "../authConfig";

export function SearchProvider({ children }: { children: React.ReactNode }) {
  return <UrlqProvider value={urqlClient}>{children}</UrlqProvider>;
}
